export default "__VITE_ASSET__DZ_CIntG__"